<div class="page-body">
  <div class="row">
    <div class="col-sm-12">
      <app-card [title]="'global.overview'|translate">
        <app-grid [grid]="grid" ></app-grid>
      </app-card>
    </div>
  </div>
</div>

<app-modal-basic #previewModal [dialogClass]="'modal-lg'">
  <div class="app-modal-header">
    <h4 class="modal-title">&nbsp;</h4>
    <button type="button" class="close basic-close" (click)="previewModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body p-0" *ngIf="iframeUrl">
    <iframe [frameBorder]="0" [src]="iframeUrl" height='450px' width="100%"></iframe>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4"   (click)="previewModal.hide()">{{'global.close'|translate}}</button>
  </div>
</app-modal-basic>

<app-modal-basic #resendModal [dialogClass]="'modal-lg'">
  <div class="app-modal-header">
    <h4 class="modal-title">{{ 'admin.emails.manage.resend_email'|translate }}</h4>
    <button type="button" class="close basic-close" (click)="resendModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body p-0" *ngIf="iframeUrl">
    <p>
      {{'admin.emails.manage.resend_email_info'|translate}}
    </p>
    <div class="form-group row">
      <div class="form-group form-default form-static-label col">
        <input class="form-control"
               placeholder="{{'doctrine.emails.to'|translate}}"
               name="to"
               email
               #to="ngModel"
               [(ngModel)]="email.to" required>
        <span class="form-bar"></span>
        <div class="messages text-danger" *ngIf="to.invalid && to.dirty && to.errors?.email">{{'errors.invalid'|translate}}</div>
        <div class="messages text-danger" *ngIf="to.invalid && to.dirty && to.errors?.required">{{'errors.required'|translate}}</div>
      </div>
      <div class="form-group form-default form-static-label col">
        <div class="email-chips-container">
          <div class="email-chips">
            <span class="email-chip" *ngFor="let email of cc">
              {{email}}
              <span class="remove-chip" (click)="removeEmail(email, 'cc')">&times;</span>
            </span>
          </div>
          <input class="form-control" 
                 type="text"
                 [(ngModel)]="ccInput"
                 name="ccInput"
                 #ccField="ngModel"
                 [email]="true"
                 (keyup.enter)="addEmail($event, 'cc')"
                 (keyup.comma)="addEmail($event, 'cc')"
                 [placeholder]="cc.length ? '+' : ('doctrine.emails.cc'|translate)">
        </div>
        <div class="messages text-danger" *ngIf="ccField.invalid && ccField.dirty && ccField.errors?.email">
          {{errorMessages.email}}
        </div>
      </div>
      <div class="form-group form-default form-static-label col">
        <div class="email-chips-container">
          <div class="email-chips">
            <span class="email-chip" *ngFor="let email of bcc">
              {{email}}
              <span class="remove-chip" (click)="removeEmail(email, 'bcc')">&times;</span>
            </span>
          </div>
          <input class="form-control" 
                 type="text"
                 [(ngModel)]="bccInput"
                 name="bccInput"
                 #bccField="ngModel"
                 [email]="true"
                 (keyup.enter)="addEmail($event, 'bcc')"
                 (keyup.comma)="addEmail($event, 'bcc')"
                 [placeholder]="bcc.length ? '+' : ('doctrine.emails.bcc'|translate)">
        </div>
        <div class="messages text-danger" *ngIf="bccField.invalid && bccField.dirty && bccField.errors?.email">
          {{errorMessages.email}}
        </div>
      </div>
      <div class="col-2">
        <button class="btn btn-block btn-sm btn-primary ripple light" (click)="resend()">{{'global.send'|translate}}</button>
      </div>
    </div>
    <iframe [frameBorder]="0" [src]="iframeUrl" height='450px' width="100%"></iframe>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4"   (click)="resendModal.hide()">{{'global.close'|translate}}</button>
  </div>
</app-modal-basic>

<ng-template #emailsTooltip let-value="value">
  <span class="tooltip-item">
    <span class="tooltipBox">
      {{value[0] ? value[0] : ('global.no' | translate) }} {{value.length > 1 ? '...' : ''}}
    </span>
    <span class="desc-place" *ngIf="value.length > 1">
      <ng-container *ngFor="let item of value; let i = index;">
        <span *ngIf="i > 0">
          {{item}} <br *ngIf="i !== (value.length - 1)">
        </span>
      </ng-container>
    </span>
  </span>
</ng-template>
